import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "userLoginView" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"32px 0"} }, "注册", -1)

import { reactive } from "vue";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { Message } from "@arco-design/web-vue";
import {
  UserControllerService,
  UserRegisterRequest,
} from "../../../backend/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserRegisterView',
  setup(__props) {

const router = useRouter();
const store = useStore();

const form = reactive<UserRegisterRequest>({
  checkPassword: "",
  userAccount: "",
  userPassword: "",
});

const handleSubmit = async () => {
  if (
    form?.checkPassword?.length !== form.userPassword?.length ||
    form.checkPassword !== form.userPassword
  ) {
    Message.error("两次输入密码不一致");
    return;
  }

  // 拿到后端的响应
  const res = await UserControllerService.userRegisterUsingPost(form);
  // 登录成功跳转到主页
  if (res.code === 0) {
    // 获取到用户信息之后再跳转到主页
    await store.dispatch("user/getLoginUser");
    await router.push({
      path: "/user/login",
      replace: true,
    });
    message.success("注册成功！");
  } else {
    message.error("注册失败！" + res.message);
  }
};
/**
 * 回到首页
 * @param question
 */
const toIndex = () => {
  router.push({
    path: `/`,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, {
      model: form,
      "auto-label-width": "",
      "label-align": "left",
      style: {"max-width":"320px","margin":"0 auto"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          rules: [
          { required: true, message: '账号不能为空' },
          { minLength: 4, message: '账号长度不能低于4位' },
        ],
          field: "userAccount",
          label: "账号",
          required: "",
          tooltip: "账号不少于 4 位"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.userAccount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userAccount) = $event)),
              placeholder: "请输入账号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          rules: [
          { required: true, message: '密码不能为空' },
          { minLength: 4, message: '密码不能小于8位' },
        ],
          field: "userPassword",
          label: "密码",
          required: "",
          tooltip: "密码不能小于8位"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.userPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.userPassword) = $event)),
              placeholder: "请输入密码"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "checkPassword",
          label: "确认密码",
          required: "",
          tooltip: "密码不少于 8 位"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.checkPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.checkPassword) = $event)),
              placeholder: "请确认密码"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_space, { wrap: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          shape: "round",
          size: "large",
          status: "success",
          type: "secondary",
          onClick: toIndex
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 首 页 ")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          "html-type": "submit",
          shape: "round",
          size: "large",
          style: {"margin":"25px","width":"150px"},
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 新 手 注 册 ")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})